import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
export class NumericSummary extends Component {
    render() {
        const { errorCount, warningCount, iconFixedWidth, className, fixesCount, t } = this.props;
        return (_jsxs("p", { className: clsx('report-detail__summary', className), children: [_jsxs("span", { className: "report-detail__issue-count text-danger", children: [_jsx(Icon, { name: "exclamation-circle", className: "report-detail__icon mr-2", fixedWidth: iconFixedWidth }), new Intl.NumberFormat(t('numberFormatLocale')).format(errorCount)] }), _jsxs("span", { className: "report-detail__issue-count text-warning", children: [_jsx(Icon, { name: "exclamation-triangle", className: "report-detail__icon mr-2", fixedWidth: iconFixedWidth }), new Intl.NumberFormat(t('numberFormatLocale')).format(warningCount)] }), !!fixesCount &&
                    _jsxs("span", { className: "report-detail__issue-count text-warning", children: [_jsx(Icon, { name: "bolt", className: "report-detail__icon mr-2", fixedWidth: iconFixedWidth }), new Intl.NumberFormat(t('numberFormatLocale')).format(fixesCount)] })] }));
    }
}
NumericSummary.defaultProps = {
    iconFixedWidth: false,
};
export default withTranslation()(NumericSummary);
